import React from "react";
import { Offcanvas, Table } from "react-bootstrap";
import Moment from "react-moment";

const FileDataProperties = ({ Show, Hide, Title, fileData }) => {
  return (
    <div>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 600 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Table className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0">
              <tr>
                <th>Attribute</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{fileData?.name}</td>
              </tr>
              <tr>
                <td>Location</td>
                <td>
                  Generate Report/Data Librtry/{fileData?.libraryName}/{fileData?.name}.glxdat
                </td>
              </tr>
              <tr>
                <td>Columns</td>
                <td>{(fileData?.column || [])?.length}</td>
              </tr>
              <tr>
                <td>Created Date | Time</td>
                <td>
                  <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                    {fileData?.createdAt}
                  </Moment>
                </td>
              </tr>
              <tr>
                <td>Modified Date | Time</td>
                <td>
                  <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                    {fileData?.updatedAt}
                  </Moment>
                </td>
              </tr>
            </tbody>
          </Table>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default FileDataProperties;
